import { get } from 'lodash-es';
import { getMixinEvents } from './manage';
export function triggerEvent(componentType, eventName, options) {
    const events = getMixinEvents(componentType);
    const event = get(events, eventName);
    event === null || event === void 0 ? void 0 : event(options);
}
